import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { twMerge } from '../../utils/twMerge.js';
/**
 * Avatars are used to represent people or entities.
 *
 * The component purely provides shaping and styling.
 * The consumer must control sizing and layout of children
 * in the component.
 */
export const Avatar = forwardRef(function Avatar({ variant = 'circle', size = '32', children, className }, forwardedRef) {
    return (_jsx("div", { ref: forwardedRef, className: twMerge(
        // component name
        'ppl-Avatar', 
        // common styles
        'flex flex-shrink-0 items-center justify-center overflow-hidden border border-default text-center font-medium text-accent', 
        // size
        {
            '16': 'h-4 w-4 text-[0.375rem]/[1.3333333333333333]', // 6px
            '24': 'h-6 w-6 text-[0.5625rem]/[1.3333333333333333]', // 9px
            '32': 'h-8 w-8 text-[0.75rem]/[1.3333333333333333]', // 12px
            '40': 'h-10 w-10 text-[0.9375rem]/[1.3333333333333333]', // 15px
            '64': 'h-16 w-16 text-[1.5rem]/[1.3333333333333333]', // 24px
        }[size], 
        // variants
        {
            circle: 'rounded-full bg-accent-subdued',
            square: 'rounded bg-default',
        }[variant], className), children: typeof children === 'function'
            ? children({
                '16': 'h-2 w-2',
                '24': 'h-3 w-3',
                '32': 'h-4 w-4',
                '40': 'h-5 w-5',
                '64': 'h-8 w-8',
            }[size])
            : children }));
});
//# sourceMappingURL=Avatar.js.map